const store = {
    namespaced: true,
    state() {
        return {
            navigationHistory: []
        }
    },
    getters: {
        navigationHistory: state => state.navigationHistory
    },
    mutations: {
        ADD_TO_HISTORY: (state, path) => {
            if (path && state.navigationHistory[state.navigationHistory.length - 1] !== path) {
                state.navigationHistory.push(path);
            }
        },
        POP_FROM_HISTORY: state => state.navigationHistory.pop()
    },
}

export default store